/**
 * Client Error Handler Component
 * Initializes global error handlers for uncaught errors and unhandled promise rejections
 */

import { useEffect } from 'react';
import { initializeErrorHandlers } from '../../utils/error-reporter';

/**
 * ClientErrorHandler Component
 * This component initializes global error handlers when the app loads
 * Should be included once at the root level of the app
 */
export function ClientErrorHandler() {
  useEffect(() => {
    // Initialize global error handlers on client-side only
    initializeErrorHandlers();
  }, []); // Empty dependency array - only run once on mount

  // This component doesn't render anything
  return null;
}
